/* import __COLOCATED_TEMPLATE__ from './header.hbs'; */
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@ember/component';
import { AccountType } from '@square/dashboard-protos/models/squareup/banking/common';
import { CurrencyCode } from '@square/dashboard-protos/models/squareup/common/currency_codes';
import { INITIAL_PAGE_SIZE } from '@banking/api/services/banking-unit-account-pagination';
import { Money } from '@square/dashboard-protos/models/squareup/connect/v2/common/money';
import { computed } from '@ember/object';
import { inject as service } from '@ember/service';
import { notEmpty, gte } from '@ember/object/computed';
import { hasIdentityVerificationRequest, hasRecasedSSPRequest, hasNeededSSPRequest } from '@banking/ui/utils/risk-utils';

// TODO(steckel): Standardize our Money and Currency representation.
// As long as we implement "money math" we need to uphold some precondition:
// that all inputs are the same currency and that the user's native currency
// remains unaltered. Ideally we wouldn't do money math at all, but that is for
// another time. Because we do money math we're forced to deal with the varying
// Money protos and their respective currency code models. This module type
// casts the squareup/common/currency_codes proto to the v2/common/money
// currency proto assuming the implementation will never change and that it can
// be safely done. It cannot, and the code that does so should be removed when
// there is a chance.

const STORED_BALANCE_TYPES = new Set([AccountType.CHECKING_ACCOUNT, AccountType.MANUAL_SETTLEMENT_CHECKING_ACCOUNT]);
function zero(currencyKind) {
  const currency = currencyKind;
  return Money.create({
    amount: 0,
    currency
  });
}
function add(forcedCurrency) {
  return function (value1, value2) {
    if (forcedCurrency == null) {
      if (value1.currency == null) {
        throw new Error('Money must have currency');
      }
      if (value1.currency !== value2.currency) {
        throw new Error('Money of different currencies cannot be added.');
      }
    }
    const currency = forcedCurrency == null ? value1.currency : forcedCurrency;
    const _value1 = value1.amount ?? 0;
    const _value2 = value2.amount ?? 0;
    return Money.create({
      amount: _value1 + _value2,
      currency
    });
  };
}
function sum(currency, values) {
  if (values.length === 0) {
    return zero(currency);
  }
  return values.reduce(add(currency), zero(currency));
}
let Header = (_dec = notEmpty('loggedInUser.firstName'), _dec2 = gte('pendingDepositBalanceTotal.amount', 0), _dec3 = computed('userInfo.currencyCode'), _dec4 = computed('balances', 'savingsAccounts.totalAndPendingBalance', 'foldersAccounts.totalAndPendingBalance'), _dec5 = computed('balances'), _dec6 = computed('currencyCode', 'storedBalances'), _dec7 = computed('currencyCode', 'pendingDepositBalances'), _dec8 = computed('storedBalanceTotal.amount', 'storedBalances.length', 'units.length'), _dec9 = computed('pendingDepositBalanceTotal.amount', 'pendingDepositBalances.length', 'units.length'), _dec10 = computed('currencyCode', 'pendingDepositBalanceTotal', 'storedBalanceTotal'), _class = class Header extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "tagName", '');
    _initializerDefineProperty(this, "userInfo", _descriptor, this);
    _initializerDefineProperty(this, "intl", _descriptor2, this);
    _initializerDefineProperty(this, "savingsAccounts", _descriptor3, this);
    _initializerDefineProperty(this, "foldersAccounts", _descriptor4, this);
    _defineProperty(this, "balances", void 0);
    _defineProperty(this, "units", void 0);
    _defineProperty(this, "loggedInUser", void 0);
    _defineProperty(this, "riskProfileUnits", void 0);
    _initializerDefineProperty(this, "hasMerchantName", _descriptor5, this);
    _initializerDefineProperty(this, "hasPositivePendingDepositTotal", _descriptor6, this);
  }
  get currencyCode() {
    return CurrencyCode[this.userInfo.currencyCode];
  }
  get storedBalances() {
    return this.balances?.reduce(function (filtered, balance) {
      if (STORED_BALANCE_TYPES.has(balance.type) && balance.availableBalance) {
        filtered.push(balance.availableBalance);
      }
      return filtered;
    }, [this.savingsAccounts.totalAndPendingBalance, this.foldersAccounts.totalAndPendingBalance]);
  }
  get pendingDepositBalances() {
    return this.balances?.reduce(function (filtered, balance) {
      if (balance.type === AccountType.CLEARING_ACCOUNT && balance.availableBalance) {
        filtered.push(balance.availableBalance);
      }
      return filtered;
    }, []);
  }
  get storedBalanceTotal() {
    return sum(this.currencyCode, this.storedBalances);
  }
  get pendingDepositBalanceTotal() {
    return sum(this.currencyCode, this.pendingDepositBalances);
  }
  get hasStoredBalance() {
    return this.units?.length < INITIAL_PAGE_SIZE && this.storedBalances?.length > 0 && this.storedBalanceTotal?.amount !== 0;
  }
  get hasPendingDepositBalance() {
    return this.units?.length < INITIAL_PAGE_SIZE && this.pendingDepositBalances?.length > 0 && this.pendingDepositBalanceTotal?.amount !== 0;
  }
  get mixedBalancesTotal() {
    return sum(this.currencyCode, [this.pendingDepositBalanceTotal, this.storedBalanceTotal]);
  }
  get showRiskText() {
    return this.riskProfileUnits?.some(unit => hasIdentityVerificationRequest(unit) || hasNeededSSPRequest(unit) || hasRecasedSSPRequest(unit));
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "savingsAccounts", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "foldersAccounts", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "hasMerchantName", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "hasPositivePendingDepositTotal", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "currencyCode", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "currencyCode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "storedBalances", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "storedBalances"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "pendingDepositBalances", [_dec5], Object.getOwnPropertyDescriptor(_class.prototype, "pendingDepositBalances"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "storedBalanceTotal", [_dec6], Object.getOwnPropertyDescriptor(_class.prototype, "storedBalanceTotal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "pendingDepositBalanceTotal", [_dec7], Object.getOwnPropertyDescriptor(_class.prototype, "pendingDepositBalanceTotal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasStoredBalance", [_dec8], Object.getOwnPropertyDescriptor(_class.prototype, "hasStoredBalance"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasPendingDepositBalance", [_dec9], Object.getOwnPropertyDescriptor(_class.prototype, "hasPendingDepositBalance"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "mixedBalancesTotal", [_dec10], Object.getOwnPropertyDescriptor(_class.prototype, "mixedBalancesTotal"), _class.prototype), _class);
export { Header as default };